<template>
  <div class="d-flex">
    <imgWithNoImageError
      :src="src"
      height="30px"
      width="30px"
      :class="'img-list-thumbnail'"
      :hover="false"
    />
    <span class="title align-self-center ml-2">{{ title }}</span>
  </div>
</template>

<script>
import imgWithNoImageError from '@/components/img-with-no-image-error.vue'

export default {
  name: 'VSelectOption',
  components: {
    imgWithNoImageError,
  },
  props: ['value', 'title'],
  computed: {
    src() {
      return this.value ? this.createFullFileAddress(this.value) : ''
    },
  },
  methods: {
    createFullFileAddress({
      baseUrl, bucketName, destination, filename,
    }) {
      return `${baseUrl + bucketName}/${destination}${filename}`
    },
  },
}
</script>
